import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/Empty_installation.svg"

const Emptyinstallation: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 300 311'} component={Icon} {...props} fill="currentColor" />
export default Emptyinstallation
